import { useNavigate, useParams } from "react-router-dom";
import { FormManageDrawer } from "../../form/form-manageDrawer";
import { FormTemplateTypeEnum } from "../../../_common/enum/forms/fomTemplateType.enum";



export const CentreFormManageDrawer = (params: { isOpen?: boolean, onClose(): void }) => {
    const { centreId } = useParams<{ centreId: string }>();

    return (
        <>
            <FormManageDrawer formType={FormTemplateTypeEnum.Centre} onClose={() => { params.onClose() }} id={centreId}></FormManageDrawer>
        </>
    );
};